import { Queue } from "@material-ui/icons";
import ApplicationResource from "../../utils/resources.enum";
import FormsCreate from "./forms-create";
import FormsEdit from "./forms-edit";
import FormsList from "./forms-list";

export const formsResource = {
    name: ApplicationResource.FORMS,
    icon: Queue,
    options: { label: "Formulários" },
    link: "/forms",
    tableName: 'forms',
    list: FormsList,
    edit: FormsEdit,
    create: FormsCreate,
    products: ['office']
};